module.exports = __webpack_public_path__ + "img/zfjs.15deead5.svg";